import type { Chat, UnlinkChatFromDocumentArgs } from '@ztechapps/common.contract'
import { useActionMutation } from '@ztechapps/common.hook'
import { unlinkChatFromDocumentMutation } from '../Inbox/graphql'

export type UseUnlinkChatFromDocumentResult = [
  unlinkChatFromDocument: (input: UnlinkChatFromDocumentArgs) => Promise<Chat>,
  { loading: boolean },
]

// Detaches a conversation from its document. A refused unlink (no edit permission, a chat of another tenant)
// rejects and is not caught here: the menu item toasts it. The response's `metadata` and `document` update the
// cached chat.
export const useUnlinkChatFromDocument = (): UseUnlinkChatFromDocumentResult => {
  const [unlinkChatFromDocument, { loading }] = useActionMutation<Chat, UnlinkChatFromDocumentArgs>({
    query: unlinkChatFromDocumentMutation,
  })

  return [unlinkChatFromDocument, { loading }]
}
